<template>
  <div>
    <b-button v-if="isIntroLayer"
              @click="learnMoreBtn"
              variant="info"
              size="sm"
              class="mr-1">
      {{ content.introLayer.learnMoreBtn }}
    </b-button>
    <b-button @click="okBtn"
              variant="primary"
              size="sm">
      {{getModalOkBtnText()}}
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'FooterBtn',
  props: {
    isIntroLayer: Boolean,
    content: Object,
  },
  methods: {
    okBtn() {
      this.$emit('setCookie');
    },
    learnMoreBtn() {
      this.$emit('learnMore');
    },
    getModalOkBtnText() {
      return this.isIntroLayer
        ? this.content.introLayer.agreeBtn
        : this.content.learnMoreLayer.agreeBtn;
    },
  },
};
</script>

<style scoped>

</style>
